module.exports = __webpack_public_path__ + "img/male-elderly-figure.2c8a232e.svg";